/**
 * Type-safe pick: returns a new object containing only the specified keys.
 */
export function pick<T extends object, K extends keyof T>(
  keys: K[],
  obj: T
): Pick<T, K> {
  const result = {} as Pick<T, K>
  for (const key of keys) {
    if (key in obj) {
      result[key] = obj[key]
    }
  }
  return result
}

/**
 * Type-safe pickBy: returns a new object containing only entries
 * whose values satisfy the predicate.
 */
export function pickBy<T extends object>(
  predicate: (value: T[keyof T], key: keyof T) => boolean,
  obj: T
): Partial<T> {
  const result = {} as Partial<T>
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      if (predicate(obj[key] as T[keyof T], key)) {
        result[key] = obj[key]
      }
    }
  }
  return result
}
